<div boardCommand class="sortingBtnWrap">
  <button mat-mini-fab color="basic" [matMenuTriggerFor]="sortingBtn" aria-label="Ordina tabella"
    [ngClass]="sortingColumn ? 'sortingSelected' : '' ">
    <mat-icon>sort</mat-icon>
  </button>
  <mat-menu #sortingBtn="matMenu" xPosition="before">

    <button mat-menu-item *ngFor="let column of sortingColumns | translateColumns:boardName; let i = index"
      (click)="onColumnButtonClick(sortingColumns[i]); $event.stopPropagation()">{{column}}
      <ng-container *ngIf="column == sortingColumn; else emptyIcon">
        <mat-icon *ngIf="sortingDirection == 'down'">arrow_drop_down</mat-icon>
        <mat-icon *ngIf="sortingDirection == 'up'">arrow_drop_up</mat-icon>
      </ng-container>
    </button>

  </mat-menu>
</div>


<ng-template #emptyIcon>
  <mat-icon></mat-icon>
</ng-template>
